import { useT } from './i18n/LanguageProvider';
import styles from './LangToggle.module.css';

/** Dezenter Sprach-Umschalter für die Self-Service-Header — „DE | EN" ist EIN Toggle, kein
 * Zwei-Button-Paar: ein Klick irgendwo im Element wechselt die Sprache. Optik unverändert (aktive
 * Sprache Medium/dunkler), semantisch ein <button> mit aria-label „Sprache wechseln".
 * 1:1 übernommen aus dem Workshops-Tool (`tro-workshops/src/components/public/LangToggle.tsx`,
 * 2026-09-15); angepasst ist nur die Anbindung an den eigenen `LanguageProvider`. „DE"/„EN"
 * stehen direkt im Markup — im Workshops-Wörterbuch sind sie in beiden Sprachen identisch. */
export function LangToggle() {
  const { lang, setLang, t } = useT();

  return (
    <button
      type="button"
      className={styles.toggle}
      aria-label={t.langToggleAria}
      onClick={() => setLang(lang === 'de' ? 'en' : 'de')}
    >
      <span className={`${styles.option} ${lang === 'de' ? styles.active : ''}`}>DE</span>
      <span className={styles.divider} aria-hidden="true">
        |
      </span>
      <span className={`${styles.option} ${lang === 'en' ? styles.active : ''}`}>EN</span>
    </button>
  );
}

export default LangToggle;
